/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import Logo from "@/components/Logo";
import { VehicleCard } from "@/pages/Landing";
import { ArrowRight, Car, Search } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function PublicFleet() {
  const [fleet, setFleet] = useState([]);
  const [q, setQ] = useState("");
  const nav = useNavigate();

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/public/fleet`).then((r) => setFleet(r.data)).catch(() => setFleet([]));
  }, []);

  const filtered = fleet.filter((v) =>
    `${v.year} ${v.make} ${v.model}`.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-white">
      <header className="sticky top-0 z-30 bg-white/85 backdrop-blur border-b border-gray-200">
        <div className="max-w-6xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between">
          <Link to="/" data-testid="fleet-nav-home"><Logo /></Link>
          <nav className="hidden md:flex items-center gap-7 text-sm font-medium text-gray-700">
            <Link to="/fleet" className="text-black">Fleet</Link>
            <Link to="/#how" className="hover:text-black">How it works</Link>
            <Link to="/#contact" className="hover:text-black">Contact</Link>
          </nav>
          <Link to="/login" className="text-sm text-gray-600 hover:text-black">Staff</Link>
        </div>
      </header>

      <section className="bg-gradient-to-b from-gray-50 to-white border-b border-gray-200">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
          <div className="overline mb-2">Browse</div>
          <h1 className="font-heading text-4xl md:text-5xl font-extrabold tracking-tight">Available cars</h1>
          <p className="text-sm md:text-base text-gray-600 mt-3 max-w-xl">
            Pick a vehicle below to reserve. Weekly rate covers unlimited mileage within the Philadelphia metro.
          </p>
          <div className="mt-6 max-w-md relative">
            <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <Input
              data-testid="public-fleet-search"
              placeholder="Search make, model…"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              className="pl-9"
            />
          </div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 md:px-6 py-12">
        {filtered.length === 0 ? (
          <div className="bg-gray-50 border border-dashed border-gray-300 rounded-lg p-12 text-center">
            <Car className="mx-auto text-gray-400 mb-3" size={32} />
            <p className="text-gray-600 mb-1">No vehicles matching your search.</p>
            <p className="text-xs text-gray-500">Call (215) 770-0679 to inquire about availability.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="public-fleet-grid">
            {filtered.map((v) => (
              <VehicleCard key={v.id} v={v} onClick={() => nav(`/book/${v.id}`)} />
            ))}
          </div>
        )}
      </section>

      <footer className="bg-gray-950 text-gray-400 py-8 text-center text-xs">
        <div className="max-w-6xl mx-auto px-4">
          <Logo variant="light" />
          <p className="mt-3">© {new Date().getFullYear()} Fair Rideshare LLC · Philadelphia, PA</p>
        </div>
      </footer>
    </div>
  );
}
